import { some } from 'lodash';

import { valueContainsTerm } from './search.util.js';

export function isCategoryTransfer(category) {
    return category && category.transfer;
}

export function isCategoryBalanceUpdate(category) {
    return category && category.balanceUpdate;
}

export function isCategoryOther(category) {
    return category && category.other;
}

export function isCategoryListable(category) {
    return !isCategoryTransfer(category) && !isCategoryBalanceUpdate(category);
}

export function categoryHasTerms(category, terms) {
    return !some(terms, (term) => !valueContainsTerm(category.name, term));
}



// WEBPACK FOOTER //
// ./src/application/util/category.util.js